var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-coupon-preview" }, [
    _c("div", { staticClass: "ctm-coupon-input-row" }, [
      _c("div", { staticClass: "ctm-coupon-input-wrap" }, [
        _c("span", { staticClass: "ctm-coupon-icon" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                }
              }),
              _vm._v(" "),
              _c("line", { attrs: { x1: "7", y1: "7", x2: "7.01", y2: "7" } })
            ]
          )
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "ctm-coupon-code-input",
          attrs: {
            type: "text",
            placeholder: _vm.field.placeholder || "Enter coupon code",
            disabled: ""
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "ctm-coupon-apply-btn",
          attrs: { type: "button", disabled: "" }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.field.button_label || "Apply") + "\n    "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.field.show_discount_line
      ? _c("div", { staticClass: "ctm-coupon-discount-line" }, [
          _c("span", { staticClass: "ctm-coupon-discount-label" }, [
            _vm._v("Discount:")
          ]),
          _vm._v(" "),
          _c("strong", { staticClass: "ctm-coupon-discount-amount" }, [
            _vm._v("— —")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", { staticClass: "contactum-help" }, [
          _vm._v(_vm._s(_vm.field.help))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }